"use client"

import { useState, useEffect } from "react"
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
  Card,
  CardContent,
  Chip,
  Avatar,
  BottomNavigation,
  BottomNavigationAction,
} from "@mui/material"
import {
  AccountCircle as AccountCircleIcon,
  Notifications as NotificationsIcon,
  CalendarToday as CalendarTodayIcon,
  Home as HomeIcon,
  Payment as PaymentIcon,
} from "@mui/icons-material"
import { toast } from "react-toastify"
import { boxService } from "../services/api" // Import boxService
import ExitToAppIcon from "@mui/icons-material/ExitToApp"
import { useNavigate } from "react-router-dom"

const ReservationBox = () => {
  const [selectedPlan, setSelectedPlan] = useState("jaafoura")
  const [boxReservations, setBoxReservations] = useState({}) // This will store dynamic status and reservation info
  const [selectedBox, setSelectedBox] = useState(null)
  const [modalOpen, setModalOpen] = useState(false)
  const [formData, setFormData] = useState({
    prenom: "",
    nom: "",
    telephone: "",
    nomCheval: "",
    notes: "",
    checkInDate: new Date().toISOString().split("T")[0], // Changed from dateReservation
    checkOutDate: new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split("T")[0], // New: default to tomorrow
  })
  const handleLogout = () => {
    localStorage.removeItem("CC_Token")
    localStorage.removeItem("user")
    toast.success("Vous avez été déconnecté avec succès.", {
      position: "top-right",
      autoClose: 3000,
    })
    setTimeout(() => navigate("/login"), 4000) // Redirect after toast
  }

  const handleNavigateToNotifications = () => {
    navigate("/notifications") // Redirige vers la page notifications
  }
  const handleProfile = () => {
    navigate("/Profile")
  }

  const plans = {
    jaafoura: {
      name: "Plan Jafoura",
      image: "/assets/jaafoura2.jpg",
      imageWidth: 3615,
      imageHeight: 3509,
      boxes: [
        { id: "A01", name: "A01", x: 1509, y: 2641, width: 89, height: 54, price: 50, dimensions: "4x3.5m" },
        { id: "A02", name: "A02", x: 1509, y: 2701, width: 92, height: 53, price: 50, dimensions: "4x3.5m" },
        { id: "A03", name: "A03", x: 1508, y: 2761, width: 93, height: 58, price: 50, dimensions: "4x3.5m" },
        { id: "A04", name: "A04", x: 1508, y: 2825, width: 93, height: 54, price: 50, dimensions: "4x3.5m" },
        { id: "A05", name: "A05", x: 1508, y: 2886, width: 93, height: 54, price: 50, dimensions: "4x3.5m" },
        { id: "A06", name: "A06", x: 1508, y: 2943, width: 93, height: 58, price: 50, dimensions: "4x3.5m" },
        { id: "A07", name: "A07", x: 1508, y: 3004, width: 93, height: 58, price: 50, dimensions: "4x3.5m" },
        { id: "A08", name: "A08", x: 1508, y: 3065, width: 93, height: 48, price: 50, dimensions: "4x3.5m" },
        { id: "A09", name: "A09", x: 1693, y: 3058, width: 80, height: 57, price: 50, dimensions: "4x3.5m" },
        { id: "A10", name: "A10", x: 1693, y: 2997, width: 80, height: 51, price: 50, dimensions: "4x3.5m" },
        { id: "A11", name: "A11", x: 1693, y: 2936, width: 80, height: 58, price: 50, dimensions: "4x3.5m" },
        { id: "A12", name: "A12", x: 1693, y: 2879, width: 80, height: 51, price: 50, dimensions: "4x3.5m" },
        { id: "A13", name: "A13", x: 1693, y: 2819, width: 80, height: 51, price: 50, dimensions: "4x3.5m" },
        { id: "A14", name: "A14", x: 1693, y: 2758, width: 80, height: 54, price: 50, dimensions: "4x3.5m" },
        { id: "A15", name: "A15", x: 1693, y: 2699, width: 80, height: 54, price: 50, dimensions: "4x3.5m" },
        { id: "A16", name: "A16", x: 1840, y: 2645, width: 71, height: 41, price: 50, dimensions: "4x3.5m" },
        { id: "A17", name: "A17", x: 1837, y: 2692, width: 74, height: 54, price: 50, dimensions: "4x3.5m" },
        { id: "A18", name: "A18", x: 1834, y: 2750, width: 77, height: 54, price: 50, dimensions: "4x3.5m" },
        { id: "A19", name: "A19", x: 1834, y: 2811, width: 77, height: 54, price: 50, dimensions: "4x3.5m" },
        { id: "A20", name: "A20", x: 1837, y: 2870, width: 74, height: 54, price: 50, dimensions: "4x3.5m" },
        { id: "A21", name: "A21", x: 1837, y: 2931, width: 74, height: 52, price: 50, dimensions: "4x3.5m" },
        { id: "B01", name: "B01", x: 1914, y: 2643, width: 73, height: 54, price: 50, dimensions: "3x3m" },
        { id: "B02", name: "B02", x: 1917, y: 2704, width: 70, height: 55, price: 50, dimensions: "3x3m" },
        { id: "B03", name: "B03", x: 1914, y: 2762, width: 73, height: 54, price: 50, dimensions: "3x3m" },
        { id: "B04", name: "B04", x: 1914, y: 2822, width: 73, height: 55, price: 50, dimensions: "3x3m" },
        { id: "B05", name: "B05", x: 1914, y: 2884, width: 73, height: 52, price: 50, dimensions: "3x3m" },
        { id: "B06", name: "B06", x: 1914, y: 2943, width: 73, height: 51, price: 50, dimensions: "3x3m" },
        { id: "B07", name: "B07", x: 1914, y: 3005, width: 73, height: 51, price: 50, dimensions: "3x3m" },
        { id: "B08", name: "B08", x: 1914, y: 3060, width: 73, height: 57, price: 50, dimensions: "3x3m" },
        { id: "B09", name: "B09", x: 2048, y: 3061, width: 77, height: 54, price: 50, dimensions: "3x3m" },
        { id: "B10", name: "B10", x: 2045, y: 3000, width: 80, height: 57, price: 50, dimensions: "3x3m" },
        { id: "B11", name: "B11", x: 2051, y: 2944, width: 74, height: 51, price: 50, dimensions: "3x3m" },
        { id: "B12", name: "B12", x: 2051, y: 2884, width: 74, height: 52, price: 50, dimensions: "3x3m" },
        { id: "B13", name: "B13", x: 2051, y: 2827, width: 74, height: 51, price: 50, dimensions: "3x3m" },
        { id: "B14", name: "B14", x: 2051, y: 2766, width: 74, height: 51, price: 50, dimensions: "3x3m" },
        { id: "B15", name: "B15", x: 2051, y: 2703, width: 74, height: 51, price: 50, dimensions: "3x3m" },
        { id: "B16", name: "B16", x: 2051, y: 2646, width: 73, height: 51, price: 50, dimensions: "3x3m" },
        { id: "B17", name: "B17", x: 2214, y: 2992, width: 77, height: 54, price: 50, dimensions: "3x3m" },
        { id: "B18", name: "B18", x: 2217, y: 3058, width: 74, height: 54, price: 50, dimensions: "3x3m" },
        { id: "B19", name: "B19", x: 2332, y: 3058, width: 51, height: 54, price: 50, dimensions: "2.5x3m" },
        { id: "B20", name: "B20", x: 2332, y: 2991, width: 51, height: 54, price: 50, dimensions: "2.5x3m" },
        { id: "B21", name: "B21", x: 2332, y: 2929, width: 51, height: 54, price: 50, dimensions: "2.5x3m" },
        { id: "B22", name: "B22", x: 2332, y: 2857, width: 51, height: 57, price: 30, dimensions: "2.5x3m" },
        { id: "C01", name: "C01", x: 1511, y: 3307, width: 58, height: 80, price: 50, dimensions: "4x3.5m" },
        { id: "C02", name: "C02", x: 1581, y: 3308, width: 58, height: 76, price: 50, dimensions: "4x3.5m" },
        { id: "C03", name: "C03", x: 1649, y: 3307, width: 57, height: 77, price: 50, dimensions: "4x3.5m" },
        { id: "C04", name: "C04", x: 1716, y: 3307, width: 57, height: 77, price: 50, dimensions: "4x3.5m" },
        { id: "C05", name: "C05", x: 1783, y: 3308, width: 57, height: 77, price: 50, dimensions: "4x3.5m" },
        { id: "C06", name: "C06", x: 1850, y: 3309, width: 57, height: 77, price: 50, dimensions: "4x3.5m" },
        { id: "C07", name: "C07", x: 1920, y: 3309, width: 54, height: 74, price: 50, dimensions: "4x3.5m" },
        { id: "C08", name: "C08", x: 1987, y: 3309, width: 58, height: 76, price: 50, dimensions: "4x3.5m" },
        { id: "C09", name: "C09", x: 2054, y: 3307, width: 58, height: 77, price: 50, dimensions: "4x3.5m" },
        { id: "C10", name: "C10", x: 2121, y: 3307, width: 58, height: 77, price: 50, dimensions: "4x3.5m" },
        { id: "C11", name: "C11", x: 2188, y: 3309, width: 58, height: 74, price: 50, dimensions: "4x3.5m" },
        { id: "C12", name: "C12", x: 2255, y: 3306, width: 58, height: 77, price: 50, dimensions: "4x3.5m" },
        { id: "C13", name: "C13", x: 1511, y: 3124, width: 58, height: 79, price: 50, dimensions: "4x3.5m" },
        { id: "C14", name: "C14", x: 1582, y: 3123, width: 57, height: 80, price: 50, dimensions: "4x3.5m" },
        { id: "C15", name: "C15", x: 1649, y: 3122, width: 57, height: 83, price: 50, dimensions: "4x3.5m" },
        { id: "C16", name: "C16", x: 1716, y: 3122, width: 57, height: 79, price: 50, dimensions: "4x3.5m" },
        { id: "C17", name: "C17", x: 2096, y: 3123, width: 57, height: 83, price: 50, dimensions: "4x3.5m" },
        { id: "C18", name: "C18", x: 2162, y: 3124, width: 61, height: 77, price: 50, dimensions: "4x3.5m" },
        { id: "C19", name: "C19", x: 2230, y: 3122, width: 61, height: 80, price: 50, dimensions: "4x3.5m" },
        { id: "D01", name: "D01", x: 3331, y: 131, width: 96, height: 68, price: 50, dimensions: "5x3.5m" },
        { id: "D02", name: "D02", x: 3437, y: 132, width: 96, height: 65, price: 50, dimensions: "5x3.5m" },
        { id: "D03", name: "D03", x: 3332, y: 208, width: 60, height: 51, price: 35, dimensions: "3x3.5m" },
        { id: "D04", name: "D04", x: 3469, y: 209, width: 64, height: 51, price: 45, dimensions: "3x3.5m" },
        { id: "D05", name: "D05", x: 3331, y: 269, width: 61, height: 51, price: 45, dimensions: "3x3.5m" },
        { id: "D06", name: "D06", x: 3469, y: 269, width: 64, height: 51, price: 45, dimensions: "3x3m" }, // Changed from 3x3.5m to 3x3m
        { id: "D07", name: "D07", x: 3469, y: 329, width: 64, height: 64, price: 45, dimensions: "3.5x3.5m" },
        { id: "D08", name: "D08", x: 3331, y: 407, width: 61, height: 45, price: 45, dimensions: "3x3.5m" },
        { id: "D09", name: "D09", x: 3469, y: 403, width: 64, height: 51, price: 45, dimensions: "3x3.5m" },
        { id: "D10", name: "D10", x: 3331, y: 464, width: 61, height: 52, price: 45, dimensions: "3x3m" }, // Changed from 3x3.5m to 3x3m
        { id: "D11", name: "D11", x: 3469, y: 462, width: 64, height: 51, price: 45, dimensions: "3x3m" }, // Changed from 3x3.5m to 3x3m
        { id: "D12", name: "D12", x: 3331, y: 524, width: 61, height: 51, price: 45, dimensions: "3x3m" }, // Changed from 3x3.5m to 3x3m
        { id: "D13", name: "D13", x: 3469, y: 524, width: 64, height: 51, price: 45, dimensions: "3x3m" },
        { id: "D14", name: "D14", x: 3328, y: 588, width: 64, height: 51, price: 45, dimensions: "3x3m" },
        { id: "D15", name: "D15", x: 3469, y: 589, width: 64, height: 48, price: 45, dimensions: "3x3m" },
        { id: "D16", name: "D16", x: 3328, y: 649, width: 64, height: 51, price: 45, dimensions: "3x3m" },
        { id: "D17", name: "D17", x: 3469, y: 647, width: 64, height: 51, price: 45, dimensions: "3x3m" },
        { id: "D18", name: "D18", x: 3331, y: 709, width: 52, height: 51, price: 45, dimensions: "3x3m" },
        { id: "D19", name: "D19", x: 3482, y: 708, width: 51, height: 51, price: 45, dimensions: "3x3m" },
        { id: "D20", name: "D20", x: 3331, y: 774, width: 52, height: 51, price: 45, dimensions: "3x3m" },
        { id: "D21", name: "D21", x: 3482, y: 771, width: 51, height: 54, price: 45, dimensions: "3x3m" },
        { id: "D22", name: "D22", x: 3331, y: 830, width: 52, height: 55, price: 45, dimensions: "3x3m" },
        { id: "D23", name: "D23", x: 3479, y: 834, width: 54, height: 54, price: 45, dimensions: "3x3m" },
        { id: "D24", name: "D24", x: 3328, y: 891, width: 55, height: 48, price: 45, dimensions: "3x3m" },
        { id: "D25", name: "D25", x: 3482, y: 890, width: 51, height: 51, price: 45, dimensions: "3x3m" },
        { id: "E01", name: "E01", x: 1675, y: 1945, width: 87, height: 58, price: 45, dimensions: "3x3m" },
        { id: "E02", name: "E02", x: 1675, y: 2026, width: 86, height: 57, price: 45, dimensions: "3x3m" },
        { id: "E03", name: "E03", x: 1675, y: 2106, width: 86, height: 54, price: 45, dimensions: "3x3m" },
        { id: "E04", name: "E04", x: 1675, y: 2186, width: 89, height: 57, price: 45, dimensions: "3x3m" },
        { id: "E05", name: "E05", x: 1795, y: 1947, width: 89, height: 58, price: 45, dimensions: "3x3m" },
        { id: "E06", name: "E06", x: 1795, y: 2028, width: 89, height: 57, price: 45, dimensions: "3x3m" },
        { id: "E07", name: "E07", x: 1795, y: 2109, width: 89, height: 55, price: 45, dimensions: "3x3m" },
        { id: "E08", name: "E08", x: 1795, y: 2185, width: 86, height: 58, price: 45, dimensions: "3x3m" },
        { id: "E09", name: "E09", x: 1925, y: 1953, width: 87, height: 54, price: 45, dimensions: "3x3m" },
        { id: "E10", name: "E10", x: 1925, y: 2033, width: 87, height: 55, price: 45, dimensions: "3x3m" },
        { id: "E11", name: "E11", x: 1925, y: 2111, width: 87, height: 55, price: 45, dimensions: "3x3m" },
        { id: "E12", name: "E12", x: 1925, y: 2192, width: 87, height: 57, price: 45, dimensions: "3x3m" },
        { id: "E13", name: "E13", x: 2040, y: 1953, width: 89, height: 55, price: 45, dimensions: "3x3m" },
        { id: "E14", name: "E14", x: 2040, y: 2033, width: 89, height: 54, price: 45, dimensions: "3x3m" },
        { id: "E15", name: "E15", x: 2040, y: 2111, width: 86, height: 55, price: 45, dimensions: "3x3m" },
        { id: "E16", name: "E16", x: 2045, y: 2192, width: 86, height: 58, price: 45, dimensions: "3x3m" },
        { id: "E17", name: "E17", x: 2168, y: 1953, width: 86, height: 58, price: 45, dimensions: "3x3m" },
        { id: "E18", name: "E18", x: 2168, y: 2033, width: 86, height: 58, price: 45, dimensions: "3x3m" },
        { id: "E19", name: "E19", x: 2168, y: 2111, width: 86, height: 58, price: 45, dimensions: "3x3m" },
        { id: "E20", name: "E20", x: 2168, y: 2192, width: 86, height: 58, price: 45, dimensions: "3x3m" },
        { id: "E21", name: "E21", x: 2290, y: 1953, width: 86, height: 58, price: 45, dimensions: "3x3m" },
        { id: "E22", name: "E22", x: 2290, y: 2033, width: 86, height: 58, price: 45, dimensions: "3x3m" },
         { id: "E23", name: "E23", x: 2290, y: 2111, width: 86, height: 58, price: 45, dimensions: "3x3m" },
           { id: "E24", name: "E24", x: 2290, y: 2192, width: 86, height: 58, price: 45, dimensions: "3x3m" },
            { id: "E25", name: "E25", x: 2288, y: 2288, width: 86, height: 58, price: 45, dimensions: "3x3m" },
{ id: "E26", name: "E26", x: 2286, y: 2369, width: 86, height: 58, price: 45, dimensions: "3x3m" },
{ id: "E27", name: "E27", x: 2286, y: 2448, width: 86, height: 58, price: 45, dimensions: "3x3m" },
{ id: "E28", name: "E28", x: 2286, y: 2526, width: 86, height: 58, price: 45, dimensions: "3x3m" },
{ id: "E29", name: "E29", x: 2286, y: 2600, width: 86, height: 58, price: 45, dimensions: "3x3m" },


      ],
    },
    blocsABC: {
      name: "BLOCS A, B, C",
      image: "/assets/Blocs A, B, C.jpg",
      imageWidth: 4455,
      imageHeight: 3409,
      boxes: [
        { id: "A01", name: "A01", x: 502, y: 327, width: 366, height: 220, price: 25, dimensions: "3x3m" },
        { id: "A02", name: "A02", x: 498, y: 567, width: 366, height: 224, price: 25, dimensions: "3x3m" },
        { id: "A03", name: "A03", x: 498, y: 811, width: 366, height: 220, price: 25, dimensions: "3x3m" },
        { id: "A04", name: "A04", x: 498, y: 1055, width: 366, height: 216, price: 25, dimensions: "3x3m" },
        { id: "A05", name: "A05", x: 502, y: 1291, width: 362, height: 225, price: 25, dimensions: "3x3m" },
        { id: "A06", name: "A06", x: 498, y: 1535, width: 366, height: 221, price: 25, dimensions: "3x3m" },
        { id: "A07", name: "A07", x: 502, y: 1779, width: 366, height: 221, price: 25, dimensions: "3x3m" },
        { id: "A08", name: "A08", x: 502, y: 2015, width: 362, height: 201, price: 25, dimensions: "3x3m" },
        { id: "A09", name: "A09", x: 1230, y: 1980, width: 323, height: 236, price: 25, dimensions: "3x3m" },
        { id: "A10", name: "A10", x: 1230, y: 1744, width: 323, height: 216, price: 25, dimensions: "3x3m" },
        { id: "A11", name: "A11", x: 1230, y: 1508, width: 323, height: 216, price: 25, dimensions: "3x3m" },
        { id: "A12", name: "A12", x: 1230, y: 1271, width: 323, height: 217, price: 25, dimensions: "3x3m" },
        { id: "A13", name: "A13", x: 1230, y: 1035, width: 323, height: 213, price: 25, dimensions: "3x3m" },
        { id: "A14", name: "A14", x: 1230, y: 795, width: 323, height: 217, price: 25, dimensions: "3x3m" },
        { id: "A15", name: "A15", x: 1234, y: 559, width: 319, height: 216, price: 25, dimensions: "3x3m" },
        { id: "A16", name: "A16", x: 1804, y: 327, width: 300, height: 177, price: 25, dimensions: "3x3m" },
        { id: "A17", name: "A17", x: 1804, y: 524, width: 300, height: 220, price: 25, dimensions: "3x3m" },
        { id: "A18", name: "A18", x: 1804, y: 760, width: 300, height: 220, price: 25, dimensions: "3x3m" },
        { id: "A19", name: "A19", x: 1800, y: 996, width: 304, height: 220, price: 25, dimensions: "3x3m" },
        { id: "A20", name: "A20", x: 1804, y: 1236, width: 300, height: 217, price: 25, dimensions: "3x3m" },
        { id: "A21", name: "A21", x: 1804, y: 1472, width: 300, height: 221, price: 25, dimensions: "3x3m" },
        { id: "B01", name: "B01", x: 2127, y: 327, width: 276, height: 224, price: 30, dimensions: "3.5x3.5m" },
        { id: "B02", name: "B02", x: 2127, y: 575, width: 276, height: 216, price: 30, dimensions: "3.5x3.5m" },
        { id: "B03", name: "B03", x: 2127, y: 811, width: 276, height: 216, price: 30, dimensions: "3.5x3.5m" },
        { id: "B04", name: "B04", x: 2123, y: 1047, width: 280, height: 217, price: 30, dimensions: "3.5x3.5m" },
        { id: "B05", name: "B05", x: 2127, y: 1287, width: 276, height: 217, price: 30, dimensions: "3.5x3.5m" },
        { id: "B06", name: "B06", x: 2127, y: 1519, width: 276, height: 221, price: 30, dimensions: "3.5x3.5m" },
        { id: "B07", name: "B07", x: 2127, y: 1764, width: 276, height: 212, price: 30, dimensions: "3.5x3.5m" },
        { id: "B08", name: "B08", x: 2127, y: 2000, width: 276, height: 216, price: 30, dimensions: "3.5x3.5m" },
        { id: "B09", name: "B09", x: 2651, y: 2000, width: 307, height: 216, price: 30, dimensions: "3.5x3.5m" },
        { id: "B10", name: "B10", x: 2651, y: 1760, width: 307, height: 216, price: 30, dimensions: "3.5x3.5m" },
        { id: "B11", name: "B11", x: 2651, y: 1523, width: 307, height: 217, price: 30, dimensions: "3.5x3.5m" },
        { id: "B12", name: "B12", x: 2651, y: 1287, width: 310, height: 217, price: 30, dimensions: "3.5x3.5m" },
        { id: "B13", name: "B13", x: 2651, y: 1051, width: 310, height: 213, price: 30, dimensions: "3.5x3.5m" },
        { id: "B14", name: "B14", x: 2651, y: 811, width: 307, height: 216, price: 30, dimensions: "3.5x3.5m" },
        { id: "B15", name: "B15", x: 2651, y: 575, width: 307, height: 216, price: 30, dimensions: "3.5x3.5m" },
        { id: "B16", name: "B16", x: 2651, y: 327, width: 307, height: 224, price: 30, dimensions: "3.5x3.5m" },
        { id: "B17", name: "B17", x: 3308, y: 1712, width: 315, height: 240, price: 30, dimensions: "3.5x3.5m" },
        { id: "B18", name: "B18", x: 3308, y: 1972, width: 315, height: 244, price: 30, dimensions: "3.5x3.5m" },
        { id: "B19", name: "B19", x: 3768, y: 1976, width: 229, height: 240, price: 30, dimensions: "3.5x3.5m" },
        { id: "B20", name: "B20", x: 3772, y: 1712, width: 228, height: 240, price: 30, dimensions: "3.5x3.5m" },
        { id: "B21", name: "B21", x: 3772, y: 1453, width: 225, height: 240, price: 30, dimensions: "3.5x3.5m" },
        { id: "B22", name: "B22", x: 3768, y: 1181, width: 229, height: 248, price: 30, dimensions: "3.5x3.5m" },
        { id: "C01", name: "C01", x: 502, y: 2972, width: 248, height: 327, price: 20, dimensions: "2.5x2.5m" },
        { id: "C02", name: "C02", x: 773, y: 2972, width: 248, height: 327, price: 20, dimensions: "2.5x2.5m" },
        { id: "C03", name: "C03", x: 1037, y: 2968, width: 252, height: 335, price: 20, dimensions: "2.5x2.5m" },
        { id: "C04", name: "C04", x: 1316, y: 2968, width: 248, height: 331, price: 20, dimensions: "2.5x2.5m" },
        { id: "C05", name: "C05", x: 1584, y: 2968, width: 248, height: 331, price: 20, dimensions: "2.5x2.5m" },
        { id: "C06", name: "C06", x: 1852, y: 2968, width: 248, height: 331, price: 20, dimensions: "2.5x2.5m" },
        { id: "C07", name: "C07", x: 2120, y: 2968, width: 244, height: 327, price: 20, dimensions: "2.5x2.5m" },
        { id: "C08", name: "C08", x: 2370, y: 2968, width: 248, height: 331, price: 20, dimensions: "2.5x2.5m" },
        { id: "C09", name: "C09", x: 2638, y: 2968, width: 248, height: 335, price: 20, dimensions: "2.5x2.5m" },
        { id: "C10", name: "C10", x: 2906, y: 2968, width: 248, height: 331, price: 20, dimensions: "2.5x2.5m" },
        { id: "C11", name: "C11", x: 3174, y: 2968, width: 248, height: 327, price: 20, dimensions: "2.5x2.5m" },
        { id: "C12", name: "C12", x: 3442, y: 2968, width: 248, height: 335, price: 20, dimensions: "2.5x2.5m" },
        { id: "C13", name: "C13", x: 502, y: 2230, width: 248, height: 332, price: 20, dimensions: "2.5x2.5m" },
        { id: "C14", name: "C14", x: 773, y: 2230, width: 248, height: 336, price: 20, dimensions: "2.5x2.5m" },
        { id: "C15", name: "C15", x: 1037, y: 2230, width: 252, height: 340, price: 20, dimensions: "2.5x2.5m" },
        { id: "C16", name: "C16", x: 1316, y: 2230, width: 248, height: 332, price: 20, dimensions: "2.5x2.5m" },
        { id: "C17", name: "C17", x: 2830, y: 2230, width: 248, height: 340, price: 20, dimensions: "2.5x2.5m" },
        { id: "C18", name: "C18", x: 3100, y: 2230, width: 252, height: 336, price: 20, dimensions: "2.5x2.5m" },
        { id: "C19", name: "C19", x: 3359, y: 2230, width: 252, height: 332, price: 20, dimensions: "2.5x2.5m" },
      ],
    },
    blocD: {
      name: "BLOC D",
      image: "/assets/Bloc D.jpg",
      imageWidth: 1772,
      imageHeight: 4505,
      boxes: [
        { id: "D01", name: "D01", x: 570, y: 73, width: 535, height: 390, price: 45, dimensions: "5x3.5m" },
        { id: "D02", name: "D02", x: 1130, y: 73, width: 535, height: 390, price: 45, dimensions: "5x3.5m" },
        { id: "D03", name: "D03", x: 570, y: 480, width: 380, height: 300, price: 45, dimensions: "3x3.5m" },
        { id: "D04", name: "D04", x: 1290, y: 480, width: 380, height: 300, price: 45, dimensions: "3x3.5m" },
        { id: "D05", name: "D05", x: 570, y: 800, width: 380, height: 300, price: 45, dimensions: "3x3.5m" },
        { id: "D06", name: "D06", x: 1290, y: 800, width: 380, height: 300, price: 45, dimensions: "3x3m" },
        { id: "D07", name: "D07", x: 1290, y: 1120, width: 380, height: 380, price: 45, dimensions: "3.5x3.5m" },
        { id: "D08", name: "D08", x: 570, y: 1520, width: 380, height: 300, price: 45, dimensions: "3x3.5m" },
        { id: "D09", name: "D09", x: 1290, y: 1510, width: 380, height: 310, price: 45, dimensions: "3x3.5m" },
        { id: "D10", name: "D10", x: 570, y: 1840, width: 380, height: 300, price: 45, dimensions: "3x3m" },
        { id: "D11", name: "D11", x: 1290, y: 1845, width: 385, height: 305, price: 45, dimensions: "3x3m" },
        { id: "D12", name: "D12", x: 570, y: 2160, width: 380, height: 300, price: 45, dimensions: "3x3m" },
        { id: "D13", name: "D13", x: 1290, y: 2175, width: 380, height: 300, price: 45, dimensions: "3x3m" },
        { id: "D14", name: "D14", x: 570, y: 2495, width: 380, height: 300, price: 45, dimensions: "3x3m" },
        { id: "D15", name: "D15", x: 1290, y: 2500, width: 380, height: 300, price: 45, dimensions: "3x3m" },
        { id: "D16", name: "D16", x: 570, y: 2825, width: 380, height: 300, price: 45, dimensions: "3x3m" },
        { id: "D17", name: "D17", x: 1290, y: 2830, width: 380, height: 300, price: 45, dimensions: "3x3m" },
        { id: "D18", name: "D18", x: 570, y: 3150, width: 330, height: 320, price: 45, dimensions: "3x3m" },
        { id: "D19", name: "D19", x: 1350, y: 3150, width: 320, height: 300, price: 45, dimensions: "3x3m" },
        { id: "D20", name: "D20", x: 570, y: 3480, width: 330, height: 300, price: 45, dimensions: "3x3m" },
        { id: "D21", name: "D21", x: 1350, y: 3480, width: 320, height: 300, price: 45, dimensions: "3x3m" },
        { id: "D22", name: "D22", x: 570, y: 3810, width: 330, height: 300, price: 45, dimensions: "3x3m" },
        { id: "D23", name: "D23", x: 1350, y: 3805, width: 320, height: 300, price: 45, dimensions: "3x3m" },
        { id: "D24", name: "D24", x: 570, y: 4120, width: 330, height: 300, price: 45, dimensions: "3x3m" },
        { id: "D25", name: "D25", x: 1350, y: 4120, width: 320, height: 300, price: 45, dimensions: "3x3m" },
      ],
    },
  }

  const boxStatuses = {
    available: "Disponible",
    reserved: "Réservé",
    pending: "En cours de réservation",
    maintenance: "Maintenance",
  }

  // Function to fetch box reservations from the backend
  const fetchBoxReservations = async () => {
    try {
      const response = await boxService.getAllBoxes() // Use boxService
      const fetchedBoxes = response.data // Array of box objects from Laravel

      // Create a map for quick lookup by box name
      const fetchedBoxesMap = fetchedBoxes.reduce((acc, box) => {
        acc[box.name] = box
        return acc
      }, {})

      // Update the boxReservations state based on fetched data
      const updatedBoxReservations = {}
      // Iterate over ALL boxes from all plans to ensure all are represented
      Object.values(plans).forEach((plan) => {
        plan.boxes.forEach((staticBox) => {
          const dynamicBoxData = fetchedBoxesMap[staticBox.id] // staticBox.id is the box name
          if (dynamicBoxData) {
            updatedBoxReservations[staticBox.id] = {
              status: dynamicBoxData.status,
              client:
                dynamicBoxData.client_prenom && dynamicBoxData.client_nom
                  ? `${dynamicBoxData.client_prenom} ${dynamicBoxData.client_nom}`
                  : null,
              cheval: dynamicBoxData.cheval_nom,
              prenom: dynamicBoxData.client_prenom,
              nom: dynamicBoxData.client_nom,
              telephone: dynamicBoxData.client_telephone,
              notes: dynamicBoxData.notes,
              checkInDate: dynamicBoxData.check_in, // Changed
              checkOutDate: dynamicBoxData.check_out, // New
            }
          } else {
            // If a box is not found in backend, check if it's an E box (part of jaafoura plan)
            // This logic seems to hardcode 'reserved' for E boxes, which might conflict with actual availability.
            // I'll keep it as is for now based on the original code, but it's unusual.
            if (staticBox.id.startsWith("E") && selectedPlan === "jaafoura") {
              // Ensure it only applies to E boxes in jaafoura plan
              updatedBoxReservations[staticBox.id] = {
                status: "reserved",
                client: "jaafoura",
                prenom: "jaafoura",
                nom: "N/A", // Added default for nom
                telephone: "N/A", // Added default for telephone
                cheval: "N/A", // Added default for cheval
                checkInDate: null, // Set to null as no actual reservation data
                checkOutDate: null, // Set to null
              }
            } else {
              // Other boxes are available by default
              updatedBoxReservations[staticBox.id] = { status: "available" }
            }
          }
        })
      })
      setBoxReservations(updatedBoxReservations)
    } catch (error) {
      console.error("Error fetching box reservations:", error)
      toast.error("Erreur lors du chargement des réservations de boxes.", { position: "top-center" })
    }
  }

  useEffect(() => {
    fetchBoxReservations()
  }, []) // Fetch once on mount

  const getBoxStatus = (boxId) => {
    const reservation = boxReservations[boxId]
    if (!reservation) return "available"
    return reservation.status
  }

  const getBoxColor = (status) => {
    switch (status) {
      case "available":
        return "#4CAF50"
      case "reserved":
        return "#F44336"
      case "pending":
        return "#FF9800"
      case "maintenance":
        return "#9E9E9E"
      default:
        return "#4CAF50"
    }
  }

  const handleBoxClick = (box) => {
    const status = getBoxStatus(box.id)
    const reservation = boxReservations[box.id]

    if (status === "available") {
      setSelectedBox(box)
      setModalOpen(true)
      // Reset form data for new reservation
      setFormData({
        prenom: "",
        nom: "",
        telephone: "",
        nomCheval: "",
        notes: "",
        checkInDate: new Date().toISOString().split("T")[0], // Reset date
        checkOutDate: new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split("T")[0], // Reset date
      })
    } else if (status === "reserved") {
      toast.info(
        `Box ${box.name} réservé par ${reservation.client} pour le cheval ${reservation.cheval}. Du ${reservation.checkInDate} au ${reservation.checkOutDate}.`,
        {
          position: "top-center",
          autoClose: 5000,
        },
      )
    } else if (status === "pending") {
      toast.info(
        `Box ${box.name} est en cours de réservation par ${reservation.client} pour le cheval ${reservation.cheval}. Du ${reservation.checkInDate} au ${reservation.checkOutDate}. En attente d'approbation.`,
        {
          position: "top-center",
          autoClose: 5000,
        },
      )
    } else if (status === "maintenance") {
      toast.warning(`Box ${box.name} en maintenance`, {
        position: "top-center",
        autoClose: 3000,
      })
    }
  }

  const calculateNights = (startDate, endDate) => {
    const start = new Date(startDate)
    const end = new Date(endDate)
    const diffTime = Math.abs(end - start)
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
    return diffDays
  }

  const handleFormSubmit = async () => {
    console.log("handleFormSubmit called")

    if (
      !formData.prenom ||
      !formData.nom ||
      !formData.telephone ||
      !formData.nomCheval ||
      !formData.checkInDate ||
      !formData.checkOutDate
    ) {
      toast.error("Veuillez remplir tous les champs obligatoires", {
        position: "top-center",
        autoClose: 3000,
      })
      console.log("Validation failed: Missing required fields")
      return
    }

    // Date validation: check-out must be after or equal to check-in
    if (new Date(formData.checkInDate) > new Date(formData.checkOutDate)) {
      toast.error("La date de départ doit être égale ou postérieure à la date d'arrivée.", {
        position: "top-center",
        autoClose: 3000,
      })
      console.log("Validation failed: Check-out date before check-in date")
      return
    }

    const numberOfNights = calculateNights(formData.checkInDate, formData.checkOutDate)
    const boxIdPrefix = selectedBox.id.charAt(0) // Get the first letter of the box ID

    if (["A", "B", "C"].includes(boxIdPrefix) && numberOfNights < 2) {
      toast.error("Pour les Blocs A, B, C, la réservation doit être d'au moins 2 nuitées.", {
        position: "top-center",
        autoClose: 5000,
      })
      console.log("Validation failed: Bloc A,B,C requires min 2 nights. Current:", numberOfNights)
      return
    }

    if (["D", "E"].includes(boxIdPrefix) && numberOfNights < 1) {
      toast.error("Pour les Blocs D et E, la réservation doit être d'au moins 1 nuitée.", {
        position: "top-center",
        autoClose: 5000,
      })
      console.log("Validation failed: Bloc D,E requires min 45 nights. Current:", numberOfNights)
      return
    }

    console.log("All client-side validations passed. Attempting to submit reservation.")

    try {
      const reservationData = {
        status: "pending", // Changed to pending for admin approval
        client_prenom: formData.prenom,
        client_nom: formData.nom,
        client_telephone: formData.telephone,
        cheval_nom: formData.nomCheval,
        notes: formData.notes,
        check_in: formData.checkInDate, // Changed
        check_out: formData.checkOutDate, // New
      }
      console.log("Reservation data being sent:", reservationData)
      await boxService.updateBox(selectedBox.id, reservationData) // Use boxService
      console.log("boxService.updateBox call successful.")

      toast.success(
        `Demande de réservation pour le Box ${selectedBox.name} envoyée. En attente d'approbation de l'admin.`,
        {
          position: "top-center",
          autoClose: 5000,
        },
      )

      fetchBoxReservations() // Re-fetch data to update UI
      setModalOpen(false)
      setSelectedBox(null)
    } catch (error) {
      console.error("Error submitting reservation:", error)
      toast.error("Erreur lors de la réservation du box.", { position: "top-center" })
    }
  }

  const handleFormChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }))
  }

  const currentPlan = plans[selectedPlan]

  // Effect to recalculate box positions on window resize or plan change
  useEffect(() => {
    const scaleBoxes = () => {
      const imgElement = document.getElementById(`plan-image-${selectedPlan}`)
      if (imgElement && currentPlan.imageWidth > 0) {
        const naturalWidth = currentPlan.imageWidth
        const displayWidth = imgElement.offsetWidth
        const ratio = naturalWidth ? displayWidth / naturalWidth : 0

        currentPlan.boxes.forEach((box) => {
          const boxElement = document.querySelector(`.box-overlay[data-box-id="${box.id}"]`)
          if (boxElement) {
            boxElement.style.left = `${box.x * ratio}px`
            boxElement.style.top = `${box.y * ratio}px`
            boxElement.style.width = `${box.width * ratio}px`
            boxElement.style.height = `${box.height * ratio}px`
            boxElement.style.fontSize = `${Math.max(6, 10 * ratio)}px` // Adjusted font size
          }
        })
      }
    }

    // Initial scaling
    const img = new Image()
    img.src = currentPlan.image
    img.onload = () => {
      scaleBoxes() // Scale after image metadata is available
      // Add a slight delay if direct onload scaling is not perfect
      setTimeout(scaleBoxes, 100)
    }

    window.addEventListener("resize", scaleBoxes)
    // Call scaleBoxes when currentPlan changes as well
    scaleBoxes()

    return () => {
      window.removeEventListener("resize", scaleBoxes)
    }
  }, [selectedPlan, currentPlan]) // Rerun when plan changes

  const handleNavigate = (path) => {
    // Replace with actual navigation if react-router-dom is used
    console.log(`Navigating to ${path}`)
    // navigate(path); // Uncomment if react-router-dom is set up
  }
  const navigate = useNavigate()

  return (
    <div className="app">
      <AppBar position="fixed" sx={{ backgroundColor: "#003366" }}>
        <Toolbar>
          <Avatar alt="Logo" src={"../assets/cej.png"} sx={{ width: 40, height: 40, marginRight: "0.5rem" }} />
          <Typography
            variant="h6"
            sx={{
              flexGrow: 1,
              fontSize: { xs: "1rem", sm: "1.25rem" },
              color: "#ffffff",
            }}
          >
            Club Équestre Jafoura
          </Typography>
          
        </Toolbar>
      </AppBar>

      <Box
        sx={{
          padding: { xs: "0.5rem", sm: "1rem" }, // Responsive padding
          paddingTop: "80px", // Account for fixed AppBar
          paddingBottom: "20px",
          backgroundColor: "#f5f5f5",
          minHeight: "100vh",
        }}
      >
        <Card sx={{ marginBottom: "1rem", padding: { xs: "0.5rem", sm: "1rem" } }}>
          <Typography variant="h6" sx={{ marginBottom: "1rem", fontSize: { xs: "1rem", sm: "1.25rem" } }}>
            Choisir un plan d'écurie
          </Typography>
          <Grid container spacing={1}>
            {Object.keys(plans).map((planKey) => (
              <Grid item xs={12} sm={4} key={planKey}>
                {" "}
                {/* Full width on xs */}
                <Button
                  variant={selectedPlan === planKey ? "contained" : "outlined"}
                  onClick={() => setSelectedPlan(planKey)}
                  sx={{
                    width: "100%",
                    backgroundColor: selectedPlan === planKey ? "#003366" : "transparent",
                    color: selectedPlan === planKey ? "#ffffff" : "#003366",
                    borderColor: "#003366",
                    fontSize: { xs: "0.8rem", sm: "0.9rem" },
                    padding: { xs: "6px 8px", sm: "6px 16px" },
                  }}
                >
                  {plans[planKey].name}
                </Button>
              </Grid>
            ))}
          </Grid>
        </Card>

        <Card sx={{ marginBottom: "1rem", padding: { xs: "0.5rem", sm: "1rem" } }}>
          <Typography variant="h6" sx={{ marginBottom: "1rem", fontSize: { xs: "1rem", sm: "1.25rem" } }}>
            Légende
          </Typography>
          <Grid container spacing={1}>
            {Object.entries(boxStatuses).map(([statusKey, statusLabel]) => (
              <Grid item xs={6} sm={3} key={statusKey}>
                <Chip
                  label={statusLabel}
                  sx={{
                    backgroundColor: getBoxColor(statusKey),
                    color: "white",
                    width: "100%",
                    fontSize: { xs: "0.7rem", sm: "0.875rem" },
                  }}
                />
              </Grid>
            ))}
          </Grid>
        </Card>

        <Card sx={{ marginBottom: "1rem" }}>
          <CardContent sx={{ padding: "0 !important" }}>
            <Box sx={{ position: "relative", width: "100%", overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
              <img
                id={`plan-image-${selectedPlan}`}
                src={currentPlan.image || "/placeholder.svg"}
                alt={currentPlan.name}
                style={{
                  width: "100%", // Image will scale with container
                  height: "auto",
                  display: "block",
                  minWidth: "600px", // Ensure a minimum width for very small screens before overflow scroll kicks in
                }}
                // onLoad logic is now in useEffect to ensure it runs after initial render and on plan change
              />
              {currentPlan.boxes.map((box) => {
                const status = getBoxStatus(box.id)
                const reservationInfo = boxReservations[box.id]
                const titleText =
                  `${box.name} - ${box.dimensions} - ${box.price}DT/nuite - ${boxStatuses[status]}` +
                  (status === "reserved" ||
                  (status === "pending" && reservationInfo?.checkInDate && reservationInfo?.checkOutDate)
                    ? ` (Du ${reservationInfo.checkInDate} au ${reservationInfo.checkOutDate})`
                    : "")
                return (
                  <Box
                    key={box.id}
                    className="box-overlay" // Used by useEffect for scaling
                    data-box-id={box.id} // Used by useEffect for scaling
                    onClick={() => handleBoxClick(box)}
                    sx={{
                      position: "absolute",
                      backgroundColor: getBoxColor(status),
                      border: "1px solid #fff", // Thinner border for smaller boxes
                      borderRadius: "2px", // Smaller radius
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      fontWeight: "bold",
                      textAlign: "center",
                      opacity: 0.85,
                      transition: "opacity 0.2s ease, transform 0.2s ease",
                      padding: "1px", // Minimal padding
                      boxSizing: "border-box",
                      // Initial styles will be overridden by useEffect scaling
                      left: "0px",
                      top: "0px",
                      width: "0px",
                      height: "0px",
                      fontSize: "8px",
                      "&:hover": {
                        opacity: 1,
                        transform: "scale(1.1)",
                        zIndex: 10,
                      },
                    }}
                    title={titleText}
                  >
                    {box.name}
                  </Box>
                )
              })}
            </Box>
          </CardContent>
        </Card>
      </Box>

      <Dialog open={modalOpen} onClose={() => setModalOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          Réserver le Box {selectedBox?.name}
          {selectedBox && (
            <Typography variant="body2" color="textSecondary">
              Dimensions: {selectedBox.dimensions} - Prix: {selectedBox.price}DT/nuite
            </Typography>
          )}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ marginTop: "0.5rem" }}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Prénom *"
                name="prenom"
                value={formData.prenom}
                onChange={(e) => handleFormChange("prenom", e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Nom *"
                name="nom"
                value={formData.nom}
                onChange={(e) => handleFormChange("nom", e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Téléphone *"
                name="telephone"
                type="string"
                value={formData.telephone}
                onChange={(e) => handleFormChange("telephone", e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Nom du cheval *"
                name="nomCheval"
                value={formData.nomCheval}
                onChange={(e) => handleFormChange("nomCheval", e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              {" "}
              {/* New field for check-in date */}
              <TextField
                fullWidth
                label="Date d'arrivée *"
                name="checkInDate"
                type="date"
                value={formData.checkInDate}
                onChange={(e) => handleFormChange("checkInDate", e.target.value)}
                required
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              {" "}
              {/* New field for check-out date */}
              <TextField
                fullWidth
                label="Date de départ *"
                name="checkOutDate"
                type="date"
                value={formData.checkOutDate}
                onChange={(e) => handleFormChange("checkOutDate", e.target.value)}
                required
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                rows={3}
                label="Notes (optionnel)"
                name="notes"
                value={formData.notes}
                onChange={(e) => handleFormChange("notes", e.target.value)}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ padding: "16px 24px" }}>
          <Button onClick={() => setModalOpen(false)} color="inherit">
            Annuler
          </Button>
          <Button onClick={handleFormSubmit} variant="contained" sx={{ backgroundColor: "#003366" }}>
            Réserver
          </Button>
        </DialogActions>
      </Dialog>

      <>
  

  <Box sx={{ position: "fixed", bottom: 0, width: "100%", zIndex: 1000 }}>
  <BottomNavigation
    sx={{
      backgroundColor: "#003366",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "50px"
    }}
  >
    <Typography sx={{ color: "#ffffff", fontSize: "14px" }}>
      Copyright © 2025 AITECH-SOLU
    </Typography>
  </BottomNavigation>
</Box>


</>

    </div>
  )
}

export default ReservationBox
